import { render, staticRenderFns } from "./SummaryRow.vue?vue&type=template&id=252cfbdd&"
import script from "./SummaryRow.vue?vue&type=script&lang=ts&"
export * from "./SummaryRow.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryRow.vue?vue&type=style&index=0&id=252cfbdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports